import { render, staticRenderFns } from "./sdproduct16.vue?vue&type=template&id=8ace955a&scoped=true"
import script from "./sdproduct16.vue?vue&type=script&lang=js"
export * from "./sdproduct16.vue?vue&type=script&lang=js"
import style0 from "./sdproduct16.vue?vue&type=style&index=0&id=8ace955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ace955a",
  null
  
)

export default component.exports